import React from 'react';
import { Box } from '@qga/roo-ui/components';

import formatMoney from '@/utils/formatMoney';

interface PriceProps {
  perTraveller: {
    amount: number;
  };
}

const Price = ({ perTraveller }: PriceProps) => (
  <>
    <Box fontSize="2xl" fontWeight="bold">
      {formatMoney(perTraveller.amount, { wholeDollars: true })}
    </Box>
    <Box>/person*</Box>
  </>
);

export default Price;
